module.exports = __webpack_public_path__ + "img/my-on.bbb84e78.png";